import { render, staticRenderFns } from "./CustomConfiguration.vue?vue&type=template&id=5522d3c2&"
import script from "./CustomConfiguration?vue&type=script&lang=js&"
export * from "./CustomConfiguration?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports